var __extends = (this && this.__extends) || (function () {
    var extendStatics = function (d, b) {
        extendStatics = Object.setPrototypeOf ||
            ({ __proto__: [] } instanceof Array && function (d, b) { d.__proto__ = b; }) ||
            function (d, b) { for (var p in b) if (b.hasOwnProperty(p)) d[p] = b[p]; };
        return extendStatics(d, b);
    };
    return function (d, b) {
        extendStatics(d, b);
        function __() { this.constructor = d; }
        d.prototype = b === null ? Object.create(b) : (__.prototype = b.prototype, new __());
    };
})();
import React, { PureComponent } from "react";
import { get } from "lodash";
import withAuth from "@irati/auth/helpers/auth/withAuth";
import { IndexRedirect, PartialRoute } from "@irati/utils/history/routing";
import Wallets, { Tenant, Reward, People } from "../containers/ReportingV2/Wallets";
import Header from "../components/ReportingV2/Header";
var WalletRoutes = /** @class */ (function (_super) {
    __extends(WalletRoutes, _super);
    function WalletRoutes() {
        return _super !== null && _super.apply(this, arguments) || this;
    }
    WalletRoutes.prototype.render = function () {
        var _a = this.props, match = _a.match, auth = _a.auth;
        var productPermissions = auth.productPermissions;
        var canManageTenantWallet = get(productPermissions, "wallet.tenantWallet");
        var showRewardWallet = get(productPermissions, "wallet.rewardWallet");
        var showUserWallet = get(productPermissions, "wallet.users");
        return (React.createElement(React.Fragment, null,
            React.createElement(Header, null),
            React.createElement(IndexRedirect, { match: match, to: "/graphs" }),
            React.createElement(PartialRoute, { match: match.url, exact: true, path: "/graphs", component: Wallets, title: "Wallets" }),
            canManageTenantWallet && (React.createElement(React.Fragment, null,
                React.createElement(PartialRoute, { match: match.url, exact: true, path: "/tenant", component: Tenant, title: "Tenant" }),
                showRewardWallet && React.createElement(PartialRoute, { match: match.url, exact: true, path: "/reward", component: Reward, title: "Reward" }))),
            showUserWallet && React.createElement(PartialRoute, { match: match.url, exact: true, path: "/people", component: People, title: "People" })));
    };
    return WalletRoutes;
}(PureComponent));
export default withAuth(WalletRoutes);
